<style>
	.bg343 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar5{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%; }
.tabbar5 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar5 span.pos{  padding:0 1vw;}
.tabbar5 span.floder{ color:#666;}
 
.tabbar5 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}



.steps{width:84vw;height:6vw;margin:0;padding:0;overflow:hidden; 
border-bottom:#f3f7f8 solid 1px;margin-top:7vw;position:relative;margin-left:7vw;
 }
.steps ul{width:65vw;height:3.5vw; float:left;box-sizing:border-box;box-sizing:border-box;position:absolute;top:0;cursor:pointer;}
.steps ul li{float:left; padding: 0 1vw;height:3.5vw;line-height:3.5vw;font-size:1.4vw;box-sizing:border-box;text-align:center;}
.steps ul li.on{border-bottom:#3268ff solid 0.15vw;color:#3268ff; }
.steps ul li:hover{background:#f1f1f1; }
  
.submitss{width:12vw;height:4vw;background:#3268ff;margin-top:1vw;border-radius:.5vw;}
.submitss span{display:block;float:left;width:6vw;text-align:center;color:#fff;font-size:1.4vw;line-height:4vw;cursor:pointer;}
.submitss img{display:block;float:left;width:2vw;margin-top:1vw;height:2vw;margin-left:1.5vw;}
.submitss:hover{background:#4C84FA;}




.template_div{margin:0;padding:0;overflow:hidden;width:84vw; margin-left:7vw;border:#f1f1f1 solid 1px;border-radius:.5vw;margin-top:0;}
.c_head{margin:0;padding:0;overflow:hidden;width:100%;background:#f6f6f6;height:4vw;}
.c_head span.c1{display:block;width:12vw;line-height:4vw;font-size:1.4vw;text-align:center;float:left;font-weight:bold;}
.c_head span.c2{display:block;line-height:4vw;font-size:1.1vw;text-align:center;float:right;color:#ffad57;padding:0 .5vw;}
.tanh{width:1.6vw;height:1.6vw;border-radius:1.6vw;background:#ffad57;float:right;margin-top:1.2vw;}
.tanh img{display:block;margin:0 auto;width:1.1vw;margin-top:.25vw;}

.code_area{margin:0;padding:0;overflow:hidden;width:100%; border-bottom:#f1f1f1 solid 1px;padding-bottom: 1vw;}
.code_area ul li{width:10.9vw;float:left;border:#f1f1f1 solid 1px;box-sizing:border-box;margin-left:1vw;height:3vw;margin-top:1vw;
      border-radius:.5vw;cursor:pointer;}
.code_area ul li span{display:block;float:left;line-height:3vw;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;}
.code_area ul li span.ca1{color:#000;font-size:1vw;padding-left:.5vw;}
.code_area ul li span.ca2{color:#3465ff;font-size:1vw;padding-left:.5vw;}
.code_area ul li:hover{background:#eee;}

.template_content{width:100%;height:10vw;}
.template_content textarea{width:94%;padding:1vw 3%;height:8vw;border:0;outline:none;font-size:1.2vw;line-height:2vw;}
textarea::placeholder{font-size:1.2vw;font-family:"黑体";color:#bbb;}
.check{width:70vw;background:#f6f6f6;height:4vw;margin-left: 14vw;}
.check span{display:block;float:left;text-align:left;font-size:1.2vw;line-height:4vw;padding-left:1vw;}
.check button{display:block;float:right;border:0;outline:none;background:#3268ff;height:4vw;color:#fff;padding:0 2vw;font-size:1.3vw;}
.check button:hover{background:#4C84FA;}




.new_template2{width:12vw;float:right;height:3vw;border:#4471ff solid 1px;margin-top:.5vw;border-radius:.5vw;cursor:pointer;}
.new_template2 img{width:2vw;margin-top:.5vw;margin-left:.5vw;display:block;float:left;margin-left:1vw;}
.new_template2 span{display:block;float:left; text-align:center;line-height:3vw;font-size:1.2vw; 
  color:#4471ff;margin-left:.6vw;}
  
  
.new_template2:hover{background:#4471ff; }
.new_template2:hover span{color:#fff;}
.mengban{width:100vw;height:100vh;position:fixed;top:0;z-index:999;
background:url(../../assets/images/yao_bg4.png) repeat;}



.progress2211{width:35vw; padding-bottom: 2vw;background:#fff;position:fixed;top:10vw;z-index:999999;left:32.5vw;border-radius:.5vw;overflow:hidden;}
.progress_hd2333{width:100%;height:4vw;font-size:1.2vw;font-weight:bold;border-bottom:#ddd solid 1px;color:#333;}
.progress_hd2333 span.ap{display:block;width:40%;margin-left:30%;float:left;line-height:4vw;text-align:center;}
.progress_hd2333 img.cha{display:block;width:2vw;height:2vw;float:right;margin-top:1vw;margin-top:1vw;cursor:pointer;}

.progress2211 button.submits33111{width:86%;margin:0 auto;height:3.5vw;background:#3465ff;display:block;margin-top:2vw;border:0;outline:none;
font-size:1.1vw;color:#ffff;border-radius:.5vw;margin-top: 2vw;}
 
.progress2211 ul{width: 90%; }
.progress2211 ul li{width: 14vw;float: left;height: 3vw;background: #fff;background: ;
  margin-left: 1vw;margin-top: 1vw;border: #eee solid 2px; 
  border-radius: 5px; cursor: pointer;color: #333;
} 
.progress2211 ul li.on{  font-weight: normal;border: #84a6ed solid 2px;}
.progress2211 ul li.adds{font-weight: normal;background: #4c84fa;color: #fff;}
.progress2211 ul li.moves{font-weight: normal;background: #ffad57;color: #fff;}
.progress2211 ul li.moves2{font-weight: normal;background: #fff;color: #333;}

.progress2211 ul li span{display: block;width: 10vw;line-height: 3vw;color: #999;
text-align: left;font-size: 1.1vw;text-overflow: ellipsis;
white-space: nowrap;overflow: hidden;float: left;
margin-left: .5vw;}
.progress2211 ul li span.ccc{color: #fff;}
.progress2211 ul li img.ccc{width: 1.2vw;height: 1.2vw;display: block;
float: right;margin-right: .3vw;margin-top: .9vw;}
.progress2211 ul li img.eee{width: 1.2vw;height: 1.2vw;display: block;
float: left;margin-left: .3vw;margin-top: .9vw;}


.progress2211 input.ddd{width:100%;display: block;margin: 0 auto;height:3vw;color: #fff;
line-height: 3vw; outline: none;border: 0;text-align: center;}
.progress2211 input.bbb{width:100%;display: block;margin: 0 auto;height:3vw;font-size: 1.1vw;text-indent:.5vw;
line-height: 3vw; outline: none;border: 0;text-align: left;}


.progress2211 input.aaa{width:10vw;display: block;margin: 0 auto;height:3vw;float: left;font-size: 1.1vw;
line-height: 3vw; outline: none;border: 0;text-align: left;margin-left: .5vw;background: none}


.progress222{width:35vw;height:20vw;background:#fff;position:fixed;top:10vw;z-index:999999;left:32.5vw;border-radius:.5vw;overflow:hidden;}
.progress_hd222{width:100%;height:4vw;font-size:1.2vw;font-weight:bold;border-bottom:#ddd solid 1px;color:#333;}
.progress_hd222 span.ap{display:block;width:40%;margin-left:30%;float:left;line-height:4vw;text-align:center;}
 

 
.progress222 p{display:block;width:90%;text-align:center;line-height:5vw;
font-size:1.2vw;margin:0 auto;
color:#333;margin-top:2vw;}
 
.confirm_boxes{width:100%;margin:0 auto;height:4vw; 
margin-top:2vw;}
.progress222 button.submits441{width:35%;margin:0 auto;height:3.5vw;background:#3465ff;display:block; 
border:0;outline:none;float:left;margin-left:5vw;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}
.progress222 button.submits441:hover{background:#4C84FA;}
 
.progress222 button.submits442{width:35%;margin:0 auto;height:3.5vw;background:#ccc;display:block; 
border:0;outline:none;float:right;margin-right:5vw;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}


.select_mb{left: 0;bottom: 0;position: absolute;width: 14vw;cursor: pointer;}
.select_mb span{display: block;width: 13vw;text-align: center;line-height: 4vw;font-size: 1.4vw;color: #fff;background: #ffad57;
height: 4vw;padding: 0 .5vw;bottom: 0;position: absolute;z-index: 99999;}
.select_mb ul{width:14vw;list-style: none;bottom: 4vw;position: absolute;border-radius:1vw;z-index: 9999;}
.select_mb ul li{width: 13vw;padding: 0 .5vw;background: #507bf1;height: 3vw;text-align: left;line-height: 3vw;color: #fff;border-bottom: #eee solid 1px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;font-size: 1.2vw;}
.select_mb ul li:hover{background: #3268ff;cursor: pointer;}


.draw2-enter-active, .draw2-leave-active {
    transition: all 0.2s linear;
    transform: translateY(0);
    
}
.draw2-enter, .draw2-leave-to /* .fade-leave-active below version 2.1.8 */ {
	transform: translateY(100%);
	 
}
</style>
<template>
	<div class="bg343">

         <transition name="draw">
		 <div class="mengban" v-show="show_ad2" ></div>
		 </transition>
		 <transition name="draw">
		 <div class="progress2211"  v-show="show_ad2" >
				  <div class="progress_hd2333"><span class="ap" @click="con()">管理短信类别排序</span><img @click="close2()" class="cha" src="../../assets/images/cha.png"></div>
				  
                       <ul>
                       	<li  @click="sel_step(item.id)" v-for="(item,index) in steps2"  @mouseover="mouseOver_step2(item.id)"  @mouseleave="mouseLeave_step2(item.id)"  :key=index :class="item.classes"  >

                       	   <span  >{{item.name}}</span>
                       	     

                        <li  class="moves"   @click="do_left()"><span class="ccc">向前排序</span><img class="eee" src="../../assets/images/upper.png?id=23"></li>
                       
                        <li  class="moves"   @click="do_right()"><span class="ccc">向后排序</span><img  class="eee" src="../../assets/images/downer.png?id=23"></li>
                      

                       </ul>
                       <div style="clear:both;"></div>
                     
				  <button   @click="sure_order()" class="submits33111"  >确定</button>
		   </div>
         </transition>









           <transition name="draw">
		 <div class="mengban" v-show="show_ad" ></div>
		 </transition>
		 <transition name="draw">
		 <div class="progress2211"  v-show="show_ad" >
				  <div class="progress_hd2333"><span class="ap" @click="con()">管理短信类别</span><img @click="close()" class="cha" src="../../assets/images/cha.png"></div>
				  
                       <ul>
                       	<li  @click="sel_step(item.id)" v-for="(item,index) in steps2"  @mouseover="mouseOver_step2(item.id)"  @mouseleave="mouseLeave_step2(item.id)"  :key=index :class="item.classes"  >

                       	   <span v-if="!item.s_name">{{item.name}}</span>
                       	   <input v-else type="text"  class="aaa" v-model="item.names">

                            <img  v-if="item.edit" src="../../assets/images/editor.png" class="eee" @click="doedit(item.id)">
                            <img  v-if="item.done" src="../../assets/images/done.png" class="eee" @click="done(item.id)">



                       		<img  src="../../assets/images/cha.png" class="ccc" @click="dels(item.name,item.id)"></li>
                       	<li v-if="adds"> <input v-model="name" type="text" class="bbb" placeholder="请输入分类名称"></li>
                        <li  class="adds" @click="adder()"><span style="color:#fff;">增加分类</span><img class="ccc" src="../../assets/images/adds.png?id=23"></li>
                         <li  class="moves" @click="listorder()"><span style="color:#fff;">管理排序</span><img class="ccc" src="../../assets/images/order.png?id=23"></li>
<!--

                        <li  class="moves" v-if="can_left" @click="do_left()"><span>向前排序</span><img  src="../../assets/images/upper.png?id=23"></li>
                        <li  class="moves2" v-else  ><span>向前排序</span><img  src="../../assets/images/upper2.png?id=23"></li>

                        <li  class="moves" v-if="can_right"  @click="do_right()"><span>向后排序</span><img  src="../../assets/images/downer.png?id=23"></li>
                        <li  class="moves2" v-else  ><span>向后排序</span><img  src="../../assets/images/downer2.png?id=213"></li>
-->

                       </ul>
                       <div style="clear:both;"></div>
                     
				  <button v-if="adds" @click="add_step()" class="submits33111"  >确定</button>
		   </div>
         </transition>


        <transition name="draw">
		 <div class="mengban" v-show="del_show"></div>
		  </transition>
		 <transition name="draw">
		 <div class="progress222" v-show="del_show">
				  <div class="progress_hd222"><span class="ap">删除提示</span></div>
				  <p  style="msg_style">是否确定删除分类：{{del_msg}}</p>  
				  <div class="confirm_boxes">
					   <button class="submits441" @click="sure_del()">确定</button>
					   <button class="submits442" @click="cancel_del()">取消</button>
				  </div>
		 </div>
         </transition>




	     <u_center  ></u_center>
	     <div class="top_area">
		    <img @click="home()" src="../../assets/images/home_icon.png">
			<div class="tabbar5">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">短信模板</span>
			   <span class="rights"></span>
			   <span class="floder">新增短信模板</span>
			</div>
		 </div>
		 <div class="steps">
		      <ul>
			     <li :class="items.class" v-for="items in steps" @click="step(items.id)">{{items.name}}</li> 
			  </ul>
			  <div @click="open()" class="new_template2" @mouseover="mouseOver_sms()"  @mouseleave="mouseLeave_sms()">
			     <img :src="sms_code" >
				 <span>管理短信类别</span>
			  </div>
		 </div>
		 <div class="template_div" style="position: relative;">
		    <div class="c_head">
			   <span class="c1">新增短信模板</span>
			   <span class="c2">模板不支持连续组合变量</span>
			   <div class="tanh">
			      <img src="../../assets/images/tan.svg">
			   </div>
			</div>
		    <div class="code_area">
			   <ul>
			     <li v-for="item in list" @click="insertAtCursor(item.value)"><span class="ca1">{{item.name}}</span><span class="ca2">{ {{item.value}} }</span></li>
			   </ul>
			</div>
		    <div class="template_content">
			   <textarea id="textarea"  placeholder="请输入短信模板内容" maxlength="300" ref="count" v-model="content" ></textarea>
			</div>
			<div class="select_mb">
				<span class="qianming" @click="sign()" v-if="!sign_selected">选择签名</span>
				<span class="qianming" @click="sign()" style="font-size: 1.2vw"  v-else>{{signname}}</span>
				   <transition name="draw2">
				      <ul v-show="sign_show">
				      	<li v-for="item in sign_list" @click="choose_sign(item.name)">{{item.name}}</li>
				      </ul>
				 </transition>
			</div>
			<div class="check">
			   <span>{{current_length}}/300</span>
			   <span>预计短信计费条数{{count}}条（每67个字符为一条计费短信）</span>
			   <button @click="add_template()">提交审核</button>
			    <button style="background: #ffad57;" @click="template_view()">短信预览</button>
			</div>
		 
		 </div>
		  
		 <div class="submitss" @click="back()" style="width:16vw;">
		      <img src="../../assets/images/pre.svg">
		     <span style="width:10vw;">查看短信模板</span>
			 
		 </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
	export default {
	    components: {
		  u_center,
	    },
		data() {
			return {
				adds:false,
				show_ad:false,
				show_ad2:false,
				del_show:false,
				del_msg:"",
				del_id:"",
				steps:[],
				steps2:[],
				list:[],
				token:"",
				content:"",
				current_length:0,
				type:"",
				name:"",
				sms_code:"https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/sms_code.png",
				can_left:false,
				can_right:false,
				sel_id:"",
				count:0,
				code:"",
				sign_show:false,
				sign_selected:false,
				signname:"选择签名",
				sign_list:[{id:1,name:"西财天府"},{id:2,name:"西财天府考试院"},{id:3,name:"西财天府艺术学院"}]
				 
			}
		},
		mounted() {
		      this.type = this.$utils.getUrlKey('type'); 
		      this.code = this.$utils.getUrlKey('code'); 

		      if(this.code){
                 	var content=localStorage.getItem("template"+this.code);	
                 	if(content){
                 		this.content=content;
                 	}
              }
		      let self=this;
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  self.get_sms_type();
				  self.get_template_value();
				  self.get_sign_list();
			  } 

		},
		methods: {
			sign(){
              this.sign_show=!this.sign_show;
			},
			choose_sign(name){
              this.signname=name
              this.sign_show=false
              this.sign_selected=true
			},
			template_view(){
				if(!this.sign_selected){
              	  this.$toast.center('请选择签名');
              	  return;
                }
				localStorage.setItem("template"+this.code,this.content);	
                localStorage.setItem("signname"+this.code,this.signname);
                this.$router.push("/templete_view2?code="+this.code);  
		    },
            close2(){
                this.show_ad2=false; 
				this.show_ad=true; 
            },
			listorder(){
				this.show_ad=false; 
				this.show_ad2=true; 
			},
			doedit(id){
                var new_list=[];                   
				this.steps2.forEach(function(obj,index){
					new_list[index]=obj;
					if(obj.id==id){
					   new_list[index].names=obj.name;
                       new_list[index].s_name=true;
                       new_list[index].done=true;
                       new_list[index].edit=false;
					} 
				});
			    this.steps2=new_list; 
			},
			mouseOver_step2(id){
                var new_list=[];                   
				this.steps2.forEach(function(obj,index){
					new_list[index]=obj;
					if(obj.id==id){
						if(!obj.s_name){
                            new_list[index].edit=true;
                        }
					} 
				});
			    this.steps2=new_list; 
			},mouseLeave_step2(id){
                var new_list=[];                   
				this.steps2.forEach(function(obj,index){
					new_list[index]=obj;
					if(obj.id==id){
					   if(!obj.s_name){
					   	new_list[index].edit=false;
					   }
                       
					} 
				});
			    this.steps2=new_list; 
			},
			cancel_del(){
                   this.del_show=false;
			},
			dels(name,id){
                   this.del_show=true;
                   this.del_msg=name;
                   this.del_id=id;
			},
		   open(){
				this.show_ad=true;
			},
			close(){
                    this.show_ad=false;
			},
		   adder(){
               this.adds=true;
		   },
		    mouseOver_sms() {
			   this.sms_code="https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/sms_code2.png";
		   },mouseLeave_sms() {
		       this.sms_code="https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/sms_code.png";
		   },
		   async insertAtCursor(myValue) {
		        myValue='{'+myValue+'}'
				const myField = document.querySelector('#textarea')
				if (myField.selectionStart || myField.selectionStart === 0) {
					var startPos = myField.selectionStart
					var endPos = myField.selectionEnd
					this.content = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
					await this.$nextTick() // 这句是重点, 圈起来
					myField.focus()
					myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
				} else {
					this.content += myValue
				}
		   },
		    back(){
		       this.$router.push("/select_template");  
		   },
		   home(){
		     this.$router.push("/");  
		   },
		   get_sms_type(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_sms_type', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.steps=data.data;	
			           self.steps2=data.data;

						 if(self.type==0 || !self.type){
						 
						   if(self.steps[0]){
								self.steps[0].class='on';
								self.type=self.steps[0].id;
						   }
						 }else{
						    
						   self.step(self.type)
						 }
							
							 	 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  } 
		      }).catch(function (error) {
			         
		      });
		   },add_step(){
                let self=this;
		      axios.post(this.$api+'/message/add_step', {
					   token:self.token,
					   name:self.name
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){  
				      self.$toast.center('添加成功');
				      self.adds=false;
				      self.name="";              
					 self.get_sms_type()  				 
				  }else{
				  	  self.$toast.center(data.msg);	
				  }
		      }).catch(function (error) {
			         
		      });
 	        },sure_del(){
                let self=this;
		      axios.post(this.$api+'/message/del_step', {
					   token:self.token,
					   id:self.del_id
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){  
				      self.$toast.center('删除成功');
				      self.del_show=false;      
					 self.get_sms_type()  				 
				  }else{
				  	  self.$toast.center(data.msg);	
				  }
		      }).catch(function (error) {
			         
		      });
 	        },sure_order(){
 	        	 let self=this;
		      axios.post(this.$api+'/message/sure_order', {
					   token:self.token,
					   list:JSON.stringify(self.steps2) 
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){  
				      self.show_ad=true;
				      self.show_ad2=false;
				      self.get_sms_type();			 
				  }else{
				  	  self.$toast.center(data.msg);	
				  }
		      }).catch(function (error) {
			         
		      });
 	        },done(id){
	              let self=this;
	              var name='';
	              this.steps2.forEach(function(obj,index){
					if(obj.id==id){
						name=obj.names;
					} 
				 });
	             
                 if(!name){
                 	 self.$toast.center('请输入名称');
                 	 return;
                 }


			      axios.post(this.$api+'/message/done', {
						   token:self.token,
						   name:name,
						   id:id
			      }).then(function (response) {  
				      let data=response.data;
					  if(data.state==1){  
					        var new_list=[];                   
							self.steps2.forEach(function(obj,index){
								new_list[index]=obj;
								if(obj.id==id){
			                       new_list[index].s_name=false;
			                       new_list[index].done=false;
			                       new_list[index].edit=false;
								} 
							});
						    self.steps2=new_list;   
						    self.get_sms_type()  				 
					  }else{
					  	  self.$toast.center(data.msg);	
					  }
			      }).catch(function (error) {
				         
			      });
 	        },
		   get_template_value(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_template_value', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.list=data.data;	 				 
				  } 
		      }).catch(function (error) {
			         
		      });
		   },get_sign_list(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_sign_list', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.sign_list=data.data;	 				 
				  } 
		      }).catch(function (error) {
			         
		      });
		   },sel_step(id,index){

                     var new_list=[];                   
				this.steps2.forEach(function(obj,index){
					new_list[index]=obj;
					if( obj.id==id){
						new_list[index].classes='on';
					}else{
					    new_list[index].classes='';
					}
				});
			    this.steps2=new_list;
			    this.sel_id=id;
			    this.can_left=true;
			    this.can_right=true;
			    
		   },do_left(){
		   	    let self=this;
                var new_list=[];   
                               
				this.steps2.forEach(function(obj,index){
					new_list[index]=obj;
					if(obj.id==self.sel_id && index>0){

                       new_list[index-1]=self.steps2[index];
                       new_list[index]=self.steps2[index-1];
					} 
				});
			    this.steps2=new_list; 
		   },do_right(){
		   	    let self=this; 
		   	      
                var new_list=[];
                var temp=[];
                var indexs="";  
                var len=this.steps2.length;
				this.steps2.forEach(function(obj,index){
					new_list[index]=obj;
					if(obj.id==self.sel_id  ){
					   if(index<(len-1)){
					     	new_list[index]=self.steps2[index+1];
                            temp=self.steps2[index];
                            if(index>0){
                            	indexs=index;
                            }else{
                            	indexs='p';
                            }
                            
					   }
					} 
				});
				 if(indexs<=(len-2) && indexs >0){
				 	if(indexs=='p'){
				 		indexs=0;
				 	}
				    new_list[indexs+1]=temp;
			     } else if(indexs=='p'){
				 	if(indexs=='p'){
				 		indexs=0;
				 	}
				    new_list[indexs+1]=temp;
			     } 
			    this.steps2=new_list; 
		   },
		   step(id){
		        var new_list2=[];                   
				this.steps.forEach(function(obj,index){
					new_list2[index]=obj;
					if( obj.id==id){
						new_list2[index].class='on';
					}else{
					    new_list2[index].class='';
					}
				});
			    this.steps=new_list2;
				this.type=id;
		   },add_template(){	 
              if(!this.sign_selected){
              	  this.$toast.center('请选择签名');
              	  return;
              }
		      let self=this;
			  self.$loading('提交中...');
		      axios.post(this.$api+'/message/add_template', {
					   token:self.token,
					   type:self.type,
					   content:self.content,
					   signname:self.signname
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){
				             self.$toast.center('添加成功，请等待审核');	
                             setTimeout(function(){
								        self.$loading.close();
										self.back();
					         },1000);				  
					 		 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  }else{
				     self.$loading.close();
				     self.$toast.center(data.msg);	
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		},watch:{
			   content(){
			     this.current_length=  this.$refs.count.value.length; 		      
			     this.count=Math.ceil(this.current_length/70);
			   }
              
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/select_add.vue